import { Routes, Route, Navigate } from "react-router-dom"
import { useAuth } from "@clerk/clerk-react"
import { LoginPage } from "@/pages/LoginPage"
import { RegisterPage } from "@/pages/RegisterPage"
import { DashboardPage } from "@/pages/DashboardPage"
import { SubjectsPage } from "@/pages/SubjectsPage"
import { UnitPage } from "@/pages/UnitPage"
import { LessonPage } from "@/pages/LessonPage"
import { ReviewPage } from "@/pages/ReviewPage"
import { TestPage } from "@/pages/TestPage"

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isLoaded, isSignedIn } = useAuth()

  if (!isLoaded) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <span className="text-sm text-muted-foreground">Loading…</span>
      </div>
    )
  }

  if (!isSignedIn) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

export function App() {
  return (
    <Routes>
      <Route path="/login/*" element={<LoginPage />} />
      <Route path="/register/*" element={<RegisterPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <DashboardPage />
          </RequireAuth>
        }
      />
      <Route
        path="/subjects"
        element={
          <RequireAuth>
            <SubjectsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/unit/:unitId"
        element={
          <RequireAuth>
            <UnitPage />
          </RequireAuth>
        }
      />
      <Route
        path="/topic/:topicId/lesson"
        element={
          <RequireAuth>
            <LessonPage />
          </RequireAuth>
        }
      />
      <Route
        path="/unit/:unitId/test"
        element={
          <RequireAuth>
            <TestPage />
          </RequireAuth>
        }
      />
      <Route
        path="/topic/:topicId/review"
        element={
          <RequireAuth>
            <ReviewPage />
          </RequireAuth>
        }
      />
      <Route
        path="/review"
        element={
          <RequireAuth>
            <ReviewPage />
          </RequireAuth>
        }
      />
    </Routes>
  )
}
